import PremiumExperienceGrid from '../../../../components/containers/PremiumExperienceGrid';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'premium-experience-grid',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PremiumExperienceGrid
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
